define((require) => {
    "use strict";

    var _                    = require("underscore"),
        Time                 = require("shared/services/Time"),
        ExperienceModel      = require("shared/ui/experience/ExperienceModel"),
        PublishableState     = require("util/PublishableState");

    /**
     * Note: any function accepting the experience collection as the second (last) argument will default to the
     *       global collection of experiences if no specific collection is supplied at call time.
     */
    var GroupUtil = { // TODO: this should really be refactored to a VariantModel for an experience/variants of it, we keep doing the same work over and over!

        LOCALIZATION: "LocalizationGroup",

        BREAKPOINT: "BreakpointGroup",

        _checkInterval: function(updated, variant, userId, interval, now) { // "now" = server time
            // Ignore if the user did the update, or if not yet edited (updated)...
            var editedBy = variant.get("editedBy");

            if (editedBy && (editedBy !== userId)) {
                var editedAt = variant.getEditedAt();
                // First check because of server/client time skew...
                if ((editedAt >= now) || (now - editedAt < interval)) {
                    updated.count++;
                    updated.variants[variant.get("id")] = variant;
                }
            }
        },

        isUpdatedWithin: function(experience, group, userId, interval, now) {
            var updated = {count: 0, variants: {}};

            if (typeof now === "undefined") {
                now = Time.server(); // server time, since all date fields are server time, e.g. "editedAt"
            }

            if (group) {
                group.getAssets().forEach((variant) => {
                    this._checkInterval(updated, variant, userId, interval, now);
                });
            } else {
                this._checkInterval(updated, experience, userId, interval, now);
            }

            return updated;
        },

        /**
         * Returns the greatest state, from the enum ordinal, of the contained assets.
         *
         * @param  {GroupModel} group                           The group containing the assets.
         *
         * @return {Object}     The <tt>PublishableState</tt> enum representing the greatest asset state.
         */
        greatestAssetsState: function(group) {
            var assets = group.getAssets(),
                highestOrdinalAsset = _.max(assets, (asset) => {
                    return PublishableState.getEnum(asset.get("state"))._ordinal;
                });

            return PublishableState.getEnum(highestOrdinalAsset.get("state"));
        },

        getState: function(publishable) {
            if (publishable instanceof ExperienceModel) {
                return publishable.getState();
            }

            // Assume it's a group...
            var assetState = GroupUtil.greatestAssetsState(publishable);

            return PublishableState.greatest(publishable.get("state"), assetState);
        },

        /**
         * @private
         *
         * Convenience method returning all variants for the specified experience, or if the experience represents
         * a breakpoint group, an array containing that group.
         *
         * @param  {ExperienceModel|GroupModel} model The model representing the publishable entity.
         * @return {Model[]}                         Array of variants.
         */
        _allVariantsOrGroup: function(model) {
            if (model instanceof ExperienceModel) {
                return [model];
            }

            return model.isOneUnit() ? [model] : model.getAssets();
        },

        /**
         * @private
         *
         * Used internally to find all slots for the supplied experience and its variants or groups.
         *
         * @param {ExperienceModel} experienceModel The experience model to find the slots for.
         * @param {Function} filterCallback         The filtering callback function.
         * @return {Channel[]}                      Array of <tt>Channel</tt>'s.
         *
         */
        _findSlots: function(experienceModel, filterCallback) {
            return _.chain(this._allVariantsOrGroup(experienceModel))
                .map(filterCallback)
                .flatten()
                .value();
        },

        /**
         * Returns an array of experience assets, with at least the specified state (or *pushed* if none defined) in the specified group.
         *
         * @param  {GroupModel} group        The group model.
         * @param  {PublishableState} state  Optional state enum.
         * @return {Object[]}                Array of experience asset objects e.g.: <tt>{resourceId: "foo", resourceType: "Experience"}</tt>
         */
        breakpointRangeAssets: function(group, state) {
            return _.chain(group.rangeAssets())
                .filter((asset) => {
                    return asset.hasAtLeastState(state || PublishableState.PUSHED);
                })
                .value();
        }
    };

    return GroupUtil;
});



// WEBPACK FOOTER //
// ./src/editor/ui/groups/GroupUtil.js